// cspell:ignore ymail sina hinet pchome
// Free / public mailbox providers can't be used as a brand domain: SendGrid
// sender authentication requires editing SPF / DKIM / DMARC records on the
// domain's DNS, which the customer does not control for these providers. A
// strictly-valid domain format (e.g. "gmail.com") would otherwise pass format
// validation and then fail DNS verification, so block it up front.
const FREE_EMAIL_DOMAINS = [
  // Google
  "gmail.com",
  "googlemail.com",
  "google.com",
  // Yahoo
  "yahoo.com",
  "yahoo.com.tw",
  "yahoo.com.hk",
  "yahoo.co.jp",
  "ymail.com",
  "rocketmail.com",
  // Microsoft
  "hotmail.com",
  "hotmail.com.tw",
  "outlook.com",
  "live.com",
  "msn.com",
  // Apple
  "icloud.com",
  "me.com",
  "mac.com",
  // Others (global)
  "aol.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "gmx.net",
  "zoho.com",
  "yandex.com",
  "mail.com",
  // China / Taiwan / HK
  "qq.com",
  "163.com",
  "126.com",
  "sina.com",
  "sina.com.cn",
  "hinet.net",
  "pchome.com.tw",
  "url.com.tw",
  "seed.net.tw",
] as const;

export const isFreeEmailDomain = (value: string): boolean => {
  const lower = value.trim().toLowerCase();
  if (!lower) return false;
  // Match the provider root exactly, and also subdomains of it
  // (e.g. "foo.gmail.com") which the customer equally can't control.
  return FREE_EMAIL_DOMAINS.some(
    (domain) => lower === domain || lower.endsWith(`.${domain}`),
  );
};
